{
  "generic": {
    "no": "Nie",
    "yes": "Tak",
    "text": "Tekst "
  },
  "consent": {
    "defaultLabelText": "Wysyłając ten formularz, wyrażasz zgodę na naszą ",
    "defaultLabelLink": "polityka prywatności"
  },
  "text": {
    "defaultHeadlineText": "To jest nagłówek",
    "defaultText": "To jest blok tekstu",
    "floatingDefaultText": "NOWOŚĆ!"
  },
  "button": {
    "submitDefaultText": "Prześlij",
    "instagramDefaultText": "Śledź nas",
    "defaultText": "Kliknij tutaj",
    "closing": "ZAMYKANIE..."
  },
  "input": {
    "emailLabel": "E-mail",
    "emailPlaceholder": "Wprowadź swój e-mail",
    "passwordLabel": "Hasło",
    "passwordPlaceholder": "Wprowadź hasło",
    "nameLabel": "Imię i nazwisko",
    "namePlaceholder": "Wprowadź swoje imię",
    "firstNameLabel": "Imię",
    "firstNamePlaceholder": "Wprowadź imię",
    "lastNameLabel": "Nazwisko",
    "lastNamePlaceholder": "Wprowadź nazwisko",
    "phoneLabel": "Telefon",
    "phonePlaceholder": "Wprowadź numer telefonu",
    "textareaLabel": "Wiadomość",
    "textareaPlaceholder": "Wprowadź swoją wiadomość",
    "regularLabel": "Tekst",
    "regularPlaceholder": "Wprowadź tekst",
    "defaultLabel": "Etykieta",
    "defaultPlaceholder": "Symbol zastępczy",
    "datePlaceholder": "Wybierz datę",
    "stepLabel": "Wprowadź tutaj swoje pytanie"
  },
  "dropdown": {
    "placeholder": "Wybierz opcję",
    "firstItem": "Opcja 1",
    "secondItem": "Opcja 2",
    "chooseCountry": "Kraj"
  },
  "buttonList": {
    "firstItem": "Opcja 1",
    "secondItem": "Opcja 2",
    "option1": "Wybór 1",
    "option2": "Wybór 2",
    "option3": "Wybór 3",
    "subscriptionItem1": "Newsletter",
    "subscriptionItem2": "Aktualizacje",
    "chooseSubscriptionTopics": "Wybierz tematy subskrypcji",
    "other": "Inne",
    "uncheck-all-label": "Nie chcę otrzymywać żadnych z tych e-maili"
  },
  "rating": {
    "rateLabel": "Oceń nas",
    "npsLabel": "Jak prawdopodobne jest, że nas polecisz?",
    "veryUnsatisfied": "Bardzo niezadowolony",
    "unsatisfied": "Niezadowolony",
    "neutral": "Neutralny",
    "satisfied": "Zadowolony",
    "loveIt": "Uwielbiam to!",
    "minValueLabel": "Niski",
    "maxValueLabel": "Wysoki",
    "minValueLabelNps": "Mało prawdopodobne",
    "maxValueLabelNps": "Bardzo prawdopodobne"
  },
  "deadline": {
    "days": "Dni",
    "hours": "Godziny",
    "minutes": "Minuty",
    "seconds": "Sekundy"
  },
  "bulletList": {
    "firstItem": "Korzyść 1",
    "secondItem": "Korzyść 2"
  },
  "discountCode": {
    "copyMessage": "Skopiowano do schowka!",
    "fallback": "WELCOME10",
    "textDefault": "Twój kod rabatowy",
    "buttonDefault": "Kopiuj"
  },
  "share": {
    "buttonText": "Udostępnij"
  },
  "common": {
    "label": "Etykieta"
  },
  "wcag": {
    "banner": "Baner promocyjny",
    "closeButton": "Zamknij",
    "submitButton": "Prześlij formularz"
  },
  "spinTheWheel": {
    "prizeWonText": "Gratulacje!",
    "prizeWonButtonText": "Odbierz nagrodę",
    "prizeLostText": "Ojej, trudno! :-(",
    "prizeLostButtonText": "Kliknij, aby zamknąć",
    "spinButtonLabel": "KRĘĆ"
  },
  "memory": {
    "resultWonText": "Dobra robota! Twój czas to {elapsedTime}",
    "resultWonButtonText": "Odbierz nagrodę"
  },
  "stepNavigation": {
    "nextButtonText": "Dalej",
    "previousButtonText": "Wstecz",
    "lastButtonText": "Zamknij",
    "submitButtonText": "Prześlij"
  },
  "defaultRealTimeMessage": {
    "validationError": "Sprawdź format przesłanych danych.",
    "unknownError": "Wystąpił nieoczekiwany problem podczas wysyłania.",
    "conflictError": "Ten użytkownik już istnieje.",
    "success": "Formularz wysłany."
  }
}
